import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import "./index.css";
import axios from "../../../axios";
import { API_CALL_URL_PRIVATE } from "../../../constants";
import Form from "react-bootstrap/Form";
import { ErrorMessage, Formik, Form as FormikForm } from "formik";
import Texterror from "../../../components/Texterror";
import DatePicker from "react-datepicker";
import moment from "moment";
import Button from "react-bootstrap/Button";
import { Link, useNavigate } from "react-router-dom";
import Ico1 from "../../../assets/img/edit.png";
import Select from "react-select";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import {
  TargetValidation
} from "../../../utils/validator";
import { ThemeContext } from "../../../providers/ThemeProvider";
import { MdOutlineDeleteOutline } from "react-icons/md";
import Swal from "sweetalert2";
import AscIcon from "../../../assets/img/desc.png";
import DescIcon from "../../../assets/img/asc.png";
import { getTableRecordWithSorting } from "../../../services";

function DetailModal(props) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [themeMode, setTheme] = useContext(ThemeContext);
  const customer_code = useSelector((state) => state.compensate.customerCode);
  const [entries, setEntries] = useState([]);
  const [targetYearData, setTargetYearData] = useState([]);
  const [payperiodList, setPayperiodList] = useState([]);
  const [payperiodYearValue, setPayperiodYearValue] = useState({});
  const [payperiodDateValue, setPayperiodDateValue] = useState({});
  const [targetList, setTargetList] = useState([]);
  const [formData, setFormData] = useState({ date: "", target: "" });
  const [editIndex, setEditIndex] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editMode, setEditMode] = useState(false); 
  const [searchActive, setSearchActive] = useState(false);
  const [sortKey, setSortKey] = useState("");
  const [sortOrder, setSortOrder] = useState(1);
  const [pageLimit, setPageLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [isInitialData, setISInitialData] = useState(false);
  const [costCenterData, setCostCenterData] = useState(null);
  const [sortType, setSortType] = useState("asc");
  const [sortName, setsortName] = useState("");


    const renderSortIcon = (key) => {
      if (sortKey !== key) return <img src={DescIcon} alt="Descending" />;
      return sortOrder === -1 ? (
        <img src={DescIcon} alt="Descending" />
      ) : sortOrder === 1 ? (
        <img src={AscIcon} alt="Ascending" />
      ) : null;
    };

    const fetchCostCenterData = async () => {
      setIsLoading(true);
      try {
        const resp = await axios.post(
          `${API_CALL_URL_PRIVATE}/IntervalFormField/fieldToCostCenterMapping`,
          {
            field_name: props.id,
            customer_code: parseInt(customer_code),
          }
        );
        
        setCostCenterData(resp?.data?.data?.result);
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      } finally {
        setIsLoading(false);
      }
    };

  

  useEffect(() => {
    if (props.show) {
        fetchCostCenterData();

    }
  }, [props.show]);

  const sortingHandle = (key) => {
    const sortdata = getTableRecordWithSorting(costCenterData, key, sortType);
    setSortType(sortType === "asc" ? "desc" : "asc");
    setCostCenterData(sortdata);
    setsortName(key);
  };

   
   





    
    
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="custom-font-size">
        <Modal.Title
          id="contained-modal-title-vcenter"
          className=" color-black text-center"
        >
          {`Details of ${props.id || ""}`}
        </Modal.Title>
      </Modal.Header>

      <>
        <div>
          <div
            className="table-responsive m-4"
            style={{ maxHeight: "500px", overflowY: "auto" }}
          >
            <table className="table filter-table">
              <thead
                class="sticky-top"
                style={{ zIndex: "10" }}
              >
                <tr className="align-middle">
                  <th className="th-cursor">No.</th>
                  <th onClick={() => sortingHandle("cost_center_name")}>
                    <div className="d-flex align-items-center">
                      Cost Center
                      <div className="ms-2 bright">
                        {sortType === "asc" &&
                        sortName === "cost_center_name" ? (
                          <img src={AscIcon} alt="" />
                        ) : (
                          <img src={DescIcon} alt="" />
                        )}
                      </div>
                    </div>
                  </th>
                  <th onClick={() => sortingHandle("type")}>
                    Type
                    <span className="ms-1 bright">
                      {sortType === "asc" && sortName === "type" ? (
                        <img src={AscIcon} alt="" />
                      ) : (
                        <img src={DescIcon} alt="" />
                      )}
                    </span>
                  </th>
                  <th
                    className="text-center"
                    onClick={() => sortingHandle("display_trend_graph")}
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      Display Trend <br />
                      Graph
                      <div className="ms-2 bright">
                        {sortType === "asc" &&
                        sortName === "display_trend_graph" ? (
                          <img src={AscIcon} alt="" />
                        ) : (
                          <img src={DescIcon} alt="" />
                        )}
                      </div>
                    </div>
                  </th>
                  <th
                    className="text-center"
                    onClick={() => sortingHandle("display_workdriver_graph")}
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      Display Workdriver
                      <br /> Graph
                      <div className="ms-1 bright">
                        {sortType === "asc" &&
                        sortName === "display_workdriver_graph" ? (
                          <img src={AscIcon} alt="" />
                        ) : (
                          <img src={DescIcon} alt="" />
                        )}
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              {!isLoading ? (
                <>
                  {costCenterData?.length > 0 ? (
                    <tbody className="table-scroll-wrapper">
                      {costCenterData?.map((Ele, i) => {
                        return (
                          <tr key={Ele?._id}>
                            <td>{i + 1}</td>
                            <td>{`${Ele?.cost_center_number} - ${Ele?.cost_center_name}${Ele?.cost_center_status ? '' : ' (In-Active)'}`}</td>
                            <td>{Ele?.type}</td>
                            <td className="text-center">
                              {Ele?.display_trend_graph}
                            </td>
                            <td className="text-center">
                              {Ele?.display_workdriver_graph}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="10">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "200px" }}
                          >
                            <p class="text-secondary display-6">
                              Oops! Data Not found
                            </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </>
              ) : (
                <>
                  <tbody>
                    <tr>
                      <td colSpan="10">
                        <div
                          className="d-flex align-items-center justify-content-center w-100"
                          style={{ height: "200px" }}
                        >
                          <span
                            class="loader"
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          ></span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </>
              )}
            </table>
          </div>
        </div>
      </>
    </Modal>
  );
}

export default DetailModal;
